import { ENTITY_TYPE, FLOW_TYPE, type FlowType } from 'consts/flows';
import type { Params } from 'react-router';
import { isCompany, isKennitala } from './kennitala';
import { isEmail, isPhoneNumber } from './string.helpers';

export function queryParams(...arg: string[]) {
	const params = new URLSearchParams(globalThis.location.search);
	return arg.map(key => params.get(key) || '');
}

export function appParams(params: Readonly<Params<string>>) {
	return {
		entityType:
			ENTITY_TYPE.LEGAL_ENTITY === params.entityType ? ENTITY_TYPE.LEGAL_ENTITY : ENTITY_TYPE.INDIVIDUAL,
		flowType: (params.flowType || FLOW_TYPE.MV) as FlowType
	};
}

export function userParams() {
	const params = new URLSearchParams(globalThis.location.hash.replace('#', '?'));
	const companyKennitala = params.get('companyKennitala') ?? '';
	const accessAoken = params.get('access_token') ?? '';
	const kennitala = params.get('kennitala') ?? '';
	const email = params.get('email') ?? '';
	const error = params.get('error') ?? '';
	const phone = params.get('phone') ?? '';
	return {
		accessAoken,
		companyKennitala: isKennitala(companyKennitala) && isCompany(companyKennitala) ? companyKennitala : '',
		email: isEmail(email) ? email : '',
		error,
		kennitala: isKennitala(kennitala) && !isCompany(kennitala) ? kennitala : '',
		phone: isPhoneNumber(phone) ? phone : ''
	};
}
